export default function EmptySearchResult() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="201"
            height="134"
            fill="none"
            viewBox="0 0 201 134"
        >
            <path
                stroke="#BFEAFF"
                strokeMiterlimit="10"
                strokeWidth="1.941"
                d="M24.95 15.857h142.966M159.225 121.445H33.684a8.716 8.716 0 01-8.735-8.735V10.12a8.717 8.717 0 018.735-8.735h125.541a8.716 8.716 0 018.734 8.735v102.59c-.043 4.839-3.939 8.735-8.734 8.735z"
            ></path>
            <path
                stroke="#BFEAFF"
                strokeMiterlimit="10"
                strokeWidth="1.941"
                d="M39.08 8.793a2.01 2.01 0 01-2.013 2.012 2.01 2.01 0 01-2.012-2.012c0-1.114.899-2.013 2.012-2.013s2.013.9 2.013 2.013zM46.913 8.793a2.01 2.01 0 01-2.012 2.012 2.01 2.01 0 01-2.012-2.012c0-1.114.899-2.013 2.012-2.013s2.012.9 2.012 2.013zM54.75 8.793a2.01 2.01 0 01-2.013 2.012 2.01 2.01 0 01-2.012-2.012c0-1.114.899-2.013 2.012-2.013s2.012.9 2.012 2.013z"
            ></path>
            <path
                fill="#F3F4F5"
                d="M92.687 130.18c21.066-2.27 88.075 3.297 82.595-7.065-.857-1.542-5.267-3.597-1.627-5.181 2.654-1.199 7.493-1.97 12.203-2.569 12.288-1.542 16.827-3.897 13.615-6.894-8.52-8.135-53.821-4.667-77.585-1.413-16.913 2.398-36.865 3.383-54.42 2.355-13.745-.813-22.394-3.211-38.493-1.927-3.982.3-7.023.771-9.249 1.371-5.737 1.498-5.952 3.725-2.912 5.737 2.398 1.713 4.11 2.441-.556 4.325-3.94 1.841-10.876 3.382-11.39 5.437-.085 2.184 4.325 4.282 12.76 4.839 6.894.471 13.102 0 19.953.171 15.157.514 25.005 5.652 43.76 3.169 4.666-.643 7.278-1.927 12.374-2.441"
            ></path>
            <path
                fill="#A3A8AF"
                d="M168.599 115.279c7.665 0 13.873-.685 13.873-1.584s-6.208-1.584-13.873-1.584c-7.664 0-13.872.685-13.872 1.584s6.208 1.584 13.872 1.584z"
                opacity="0.5"
            ></path>
            <path
                fill="url(#paint0_linear)"
                d="M184.016 89.075c-.514-2.954-1.97-5.566-2.997-8.349-1.285-3.597-.686-6.465.256-10.02 1.456-5.351 1.456-11.346-1.327-16.27-.771-1.327-1.798-2.483-2.526-3.853-.856-1.456-1.242-3.383-1.413-5.053-.171-1.584.128-3.211.043-4.795a16.428 16.428 0 00-.643-4.068c-.984-3.725-3.682-8.564-8.178-8.52-5.266.042-6.636 6.422-6.465 10.575.128 2.869.642 5.952-.428 8.735-1.114 2.997-4.068 4.838-5.738 7.493-2.483 3.896-2.997 8.992-1.242 13.316.985 2.44 3.126 4.624 3.212 7.322.085 3.168-3.383 5.01-4.924 7.365-2.655 3.939-2.783 9.077-.942 13.401 4.581 9.591 17.255 12.974 26.247 7.579.128.043.3 0 .428-.086 4.539-3.553 7.622-8.948 6.637-14.772z"
            ></path>
            <path
                fill="#49A6D6"
                d="M167.618 113.224c.086-4.624.129-9.291.214-13.916a44.673 44.673 0 01-7.022-10.361c-.257-.514.557-.814.771-.3a42.093 42.093 0 006.294 9.42c.043-3.94.086-7.836.171-11.775-.042 0-.085-.043-.085-.086-2.912-3.211-5.352-6.765-7.408-10.618-.256-.471.557-.814.814-.3 1.841 3.51 4.11 6.765 6.722 9.762l.129-11.047a53.089 53.089 0 01-5.138-7.535c-.257-.472.428-.985.685-.514 1.327 2.355 2.826 4.581 4.453 6.722.043-3.682.085-7.322.085-11.004-.042-.043-.085-.043-.128-.128-1.285-1.542-2.526-3.083-3.64-4.71-.299-.429.386-.985.686-.514.984 1.413 2.012 2.783 3.125 4.067 0-2.44.043-4.924.043-7.364 0-.557.856-.642.856-.086 0 3.383-.042 6.765-.085 10.19a64.163 64.163 0 012.868-4.624c.3-.47.985.043.686.514-1.285 1.884-2.441 3.854-3.554 5.866-.043 2.997-.043 5.995-.086 8.95v.085c0 1.67-.043 3.34-.043 5.01a51.12 51.12 0 006.509-9.12c.256-.472 1.027-.13.77.342a51.045 51.045 0 01-7.279 10.062c-.043 4.239-.085 8.52-.171 12.76 2.012-2.184 4.068-4.325 6.08-6.509.385-.385 1.071.129.685.514a1066.123 1066.123 0 00-6.765 7.236c-.086 6.38-.171 12.76-.3 19.14-.085.513-.942.428-.942-.129z"
            ></path>
            <path
                fill="url(#paint1_linear)"
                d="M38.475 87.234c-.428-2.483-1.67-4.71-2.526-7.065-1.113-3.04-.556-5.48.214-8.478 1.2-4.538 1.242-9.59-1.113-13.744-.642-1.156-1.498-2.14-2.14-3.254-.729-1.242-1.028-2.869-1.2-4.282-.128-1.327.129-2.697.043-4.068-.043-1.156-.257-2.312-.556-3.468-.857-3.168-3.126-7.236-6.894-7.193-4.453.043-5.61 5.438-5.48 8.949.085 2.44.513 5.052-.343 7.364-.942 2.57-3.426 4.068-4.839 6.337-2.098 3.297-2.526 7.622-1.07 11.261.813 2.056 2.612 3.897 2.697 6.209.086 2.655-2.825 4.239-4.196 6.208-2.226 3.34-2.355 7.707-.813 11.347 3.896 8.135 14.6 10.961 22.18 6.38.128.043.256 0 .342-.086 3.896-2.954 6.508-7.536 5.694-12.417z"
            ></path>
            <path
                fill="#49A6D6"
                d="M24.604 107.616c.085-3.939.128-7.836.171-11.775-2.398-2.655-4.41-5.566-5.952-8.777-.214-.429.471-.686.685-.257a36.898 36.898 0 005.31 7.964l.128-9.977c-.043 0-.043-.043-.085-.085-2.484-2.74-4.539-5.738-6.252-8.992-.214-.428.471-.685.685-.257a42.318 42.318 0 005.695 8.264c.043-3.126.086-6.252.086-9.335a49.45 49.45 0 01-4.368-6.38c-.214-.385.343-.856.6-.427 1.113 1.97 2.398 3.853 3.768 5.694.043-3.125.043-6.208.085-9.334-.043 0-.085-.043-.128-.086a45.036 45.036 0 01-3.083-3.982c-.257-.385.3-.813.557-.428a41.322 41.322 0 002.654 3.468c0-2.098.043-4.153.043-6.25 0-.472.728-.558.728-.087 0 2.87-.043 5.738-.086 8.607.771-1.328 1.585-2.655 2.398-3.94.257-.385.814.043.557.429a72.769 72.769 0 00-2.997 4.967c-.043 2.526-.043 5.052-.086 7.578v.086c0 1.413-.043 2.826-.043 4.239 2.098-2.355 3.982-4.924 5.48-7.75.215-.386.9-.086.643.3-1.713 3.082-3.768 5.951-6.166 8.52l-.128 10.833 5.138-5.523c.3-.343.9.085.557.428-1.927 2.055-3.811 4.11-5.738 6.123l-.257 16.227c.129.471-.6.386-.6-.085z"
            ></path>
            <path
                fill="#CBCFD3"
                d="M115.521 56.333H57.719v57.693h57.802V56.333z"
                opacity="0.7"
            ></path>
            <path
                fill="#A3A8AF"
                d="M115.465 114.024l14.342-14.776V41.553l-14.342 14.777v57.693z"
                opacity="0.7"
            ></path>
            <path
                fill="#BBBFC4"
                d="M115.466 56.33l14.342-14.776H72.006L57.72 56.331h57.747z"
                opacity="0.7"
            ></path>
            <path
                fill="#E2E2E2"
                d="M96.78 41.556L82.492 56.332v11.626h8.203V56.332l14.288-14.776H96.78z"
                opacity="0.7"
            ></path>
            <path
                fill="#A3A8AF"
                d="M64.383 131.251c8.52 0 15.414-1.542 15.414-3.426 0-1.884-6.893-3.425-15.414-3.425-8.52 0-15.414 1.541-15.414 3.425s6.893 3.426 15.414 3.426z"
                opacity="0.5"
            ></path>
            <path
                fill="#A3A8AF"
                d="M102.363 96.954l-5.053-5.052 5.053-5.052a2.714 2.714 0 000-3.854l-.3-.3a2.713 2.713 0 00-3.853 0l-5.053 5.053-5.052-5.053a2.713 2.713 0 00-3.854 0l-.3.3a2.713 2.713 0 000 3.854l5.053 5.052-5.053 5.052a2.713 2.713 0 000 3.854l.3.3a2.714 2.714 0 003.854 0l5.052-5.053 5.053 5.053a2.714 2.714 0 003.853 0l.3-.3c1.07-1.028 1.07-2.783 0-3.854z"
            ></path>
            <path
                fill="#1E5B89"
                d="M83.48 105.004l-3.468-3.468-13.615 13.616 3.468 3.468 13.616-13.616z"
            ></path>
            <path
                fill="#000"
                d="M82.882 105.175a14.483 14.483 0 01-2.441-3.211l-.385-.385-2.484 2.483a18.923 18.923 0 003.04 3.854l2.484-2.484a1.381 1.381 0 00-.214-.257z"
                opacity="0.2"
            ></path>
            <path
                fill="#F95B03"
                d="M57.79 128.424l-1.199-1.199a3.127 3.127 0 010-4.453l14.687-14.686a3.127 3.127 0 014.453 0l1.199 1.199a3.127 3.127 0 010 4.453l-14.687 14.686a3.127 3.127 0 01-4.453 0z"
            ></path>
            <path
                fill="#fff"
                d="M77.444 109.842l-1.756-1.755c.942.942.942 2.441 0 3.34l-15.757 15.757c-.941.941-2.44.941-3.34 0l1.756 1.755c.942.942 2.44.942 3.34 0l15.757-15.757c.942-.899.942-2.398 0-3.34z"
                opacity="0.2"
            ></path>
            <path
                fill="#1E5B89"
                d="M106.217 78.8c-7.236-7.236-18.968-7.236-26.161 0-7.236 7.236-7.236 18.968 0 26.161 7.236 7.236 18.968 7.236 26.161 0 7.237-7.236 7.237-18.968 0-26.161zm-23.678 23.678c-5.866-5.866-5.866-15.329 0-21.152 5.866-5.866 15.329-5.866 21.152 0 5.866 5.866 5.866 15.329 0 21.152-5.823 5.823-15.286 5.823-21.152 0z"
            ></path>
            <path
                fill="#000"
                d="M104.546 80.47c-6.294-6.295-16.484-6.295-22.779 0-6.294 6.293-6.294 16.484 0 22.778 6.295 6.294 16.485 6.294 22.779 0 6.294-6.294 6.294-16.485 0-22.779zm-22.008 22.007c-5.866-5.866-5.866-15.328 0-21.151 5.866-5.866 15.329-5.866 21.152 0 5.866 5.866 5.866 15.328 0 21.151-5.823 5.823-15.286 5.823-21.152 0z"
                opacity="0.2"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear"
                    x1="165.644"
                    x2="169.497"
                    y1="56.802"
                    y2="163.846"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#8FD8FC"></stop>
                    <stop offset="1" stopColor="#8FD8FC" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="23.956"
                    x2="23.956"
                    y1="78.933"
                    y2="158.574"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#BFEAFF"></stop>
                    <stop offset="1" stopColor="#BFEAFF" stopOpacity="0"></stop>
                </linearGradient>
            </defs>
        </svg>
    )
}